// Configuration file for Sales Guru Superadmin Portal
// Values are injected at build time from .env files

/**
 * Parses REACT_APP_WHITELISTED_IDS into the client-side allowlist.
 *
 * Fails closed: an unset or empty value yields an EMPTY allowlist, which
 * denies everyone. This mirrors backend-tenant's `requireSuperAdmin`, where an
 * unconfigured `WHITELISTED_IDS` rejects every request rather than falling
 * back to a built-in uid. The backend allowlist stays authoritative — this
 * gate only decides what the UI renders.
 */
function parseWhitelistedIds(rawIds: string | undefined): string[] {
  return (rawIds || '')
    .split(',')
    .map((uid) => uid.trim())
    .filter((uid) => uid.length > 0);
}

export const config = {
  api: {
    // Base URL of the backend-tenant service (hosts /api/superadmin/*).
    baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5050',
  },
  app: {
    name: process.env.REACT_APP_NAME || 'Apexia Labs Admin',
    // Stamped by CI at build time; '0.0.0' marks an unstamped local build.
    version: process.env.REACT_APP_VERSION || '0.0.0',
    environment: process.env.REACT_APP_ENVIRONMENT || 'development',
    logLevel: 'INFO',
  },
  auth: {
    /** Keep in sync with backend-tenant WHITELISTED_IDS. */
    whitelistedIds: parseWhitelistedIds(process.env.REACT_APP_WHITELISTED_IDS),
  },
};

/** True when the Firebase UID is on the client-side allowlist. */
export function isWhitelisted(uid: string | null | undefined): boolean {
  return !!uid && config.auth.whitelistedIds.includes(uid);
}
